interface PageContentProps {
  children: React.ReactNode;
}

export const PageContent: React.FC<PageContentProps> = ({ children }) => {
  return (
    <div className="container flex flex-col flex-1 p-5 mx-auto">{children}</div>
  );
};
